import { getPosExportLink } from './export-link';
import { getMany } from './get-many';
import { getPosCommissions } from './pos-index';

export const CommissionsAPI = {
  getPosCommissions,
  getPosExportLink,
  getMany,
};
